module.exports = __webpack_public_path__ + "img/compact.204b4e39.png";